import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GridApi, ColDef, GridReadyEvent } from 'ag-grid-community';
import { DataTable } from 'simple-datatables';
import { AlertService } from 'src/app/_services/alert.service';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { MenusService } from 'src/app/_services/menu.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import Swal from 'sweetalert2';
import { CustomerService } from '../../customers/customer-service';
import { MerchantService } from '../../reseller-setup/merchant.service';
import { TransactionMasterService } from '../../fraud-prevention/transaction-master-rule/transaction-master-service';

@Component({
  selector: 'app-merchant-withdrawal-action',
  templateUrl: './merchant-withdrawal-action.component.html',
  styleUrls: ['./merchant-withdrawal-action.component.scss']
})
export class MerchantWithdrawalActionComponent implements OnInit {
  
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  merchantstatusform: FormGroup;
  isForm1Submitted: boolean;
  @Input() merchantStatusConfig: any;
  @Input() onMerchantMId: EventEmitter<any> = new EventEmitter<any>();
  data: any;
  Resdata: any;
  status : any;
  registeredMobile : any
  loading: boolean =false;
  remarkData: any=[]; 
  dataTable: DataTable;
  segmentData: any;
  auditData : any[];
  private gridApi!: GridApi;
  showLimitedStatus: boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
  txnId: any;
  constructor(private alertService: AlertService, private formbuilder: FormBuilder,private customerService : CustomerService,private router : Router,private transactionService: TransactionMasterService) {

    this.data = this.merchantStatusConfig
    this.merchantstatusform = formbuilder.group({
      Status: ["",[ Validators.required]],
      Remark: ["", [Validators.required,moreThanOneWhiteSpaceValidator(),Validators.maxLength(200)]],
    })
  }

  get form1() {
    return this.merchantstatusform.controls;
  }

  ngOnInit(): void {
    console.log("Blocked Component");
    this.auditData = [];
    this.onMerchantMId.subscribe((res) => (
      console.log(JSON.stringify(res)),
      this.status = res.status,
      this.txnId = res.txnId,
      this.merchantstatusform.get('Status')?.reset(),
      this.loading = false,
      this.isForm1Submitted = false
      ))
 
  }

  CustomerWalletStatusChange(formvalue : any){
   console.log("Transaction Id :"+this.txnId);
   console.log("Status :"+formvalue.Status);
   console.log("Comment :"+formvalue.Remark);
   if(this.status == formvalue.Status){
    let tempStatus = this.status || TitleCasePipe
    this.alertService.errorAlertWithMessage("Status is already "+tempStatus);
    return;
   }
   if (this.merchantstatusform.valid) {
      if(formvalue.Status=='CANCELLED'){
        this.cancelRequest(this.txnId)
      }else{
        this.transactionCompleteRequest(formvalue)
      }
    }else{
      this.alertService.errorAlertWithMessage("Mandatory Fields are missing");
        console.log("Not Valid"); 
    } 

  }

  cancelRequest(data: any) {
    console.log(data);
    console.log(data);
    this.transactionService.cancelMerchantWithdrawl(data).subscribe((response: any) => {

      console.log("Response" + JSON.stringify(response.response.message));
      if (response.response.status == 200) {
        this.closeModal.emit({
          showModal: false
        })
        Swal.fire('Merchant withdrawal canceled', '', 'success')
        this.router.navigate(['/merchantWithDrawalReport']);
        return;
      } else {
        this.closeModal.emit({
          showModal: false
        })
        Swal.fire(response.response.message, '', 'error')
        this.router.navigate(['/merchantWithDrawalReport']);
        return;
      }
    })
  }

  transactionCompleteRequest(data: any) {
    console.log(data);
    console.log(data);
    const request = {
      "txnId": this.txnId,
      "status": data.Status,
      "remarks": data.Remark
    }
    this.transactionService.completeMerchantWithdrawl(request).subscribe((response: any) => {

      console.log("Response" + JSON.stringify(response.response.message));
      if (response.response.status == 200) {
        this.closeModal.emit({
          showModal: false
        })
        Swal.fire('Merchant withdrawal completed', '', 'success')
        this.router.navigate(['/merchantWithDrawalReport']);
        return;
      } else {
        this.closeModal.emit({
          showModal: false
        })
        Swal.fire(response.response.message, '', 'error')
        this.router.navigate(['/merchantWithDrawalReport']);
        return;
      }
    })
  }

}
